import React, { useEffect, useState } from "react";
import { observer, inject } from "mobx-react";
//import { withRouter } from "react-router";
import { useNavigate, useParams, useLocation } from "react-router-dom";

//import CircularProgress from "@mui/material/CircularProgress";
import "./index.scss";
import ScreenZone from "./screenZone";

//import { runEvent } from "Utils";

function Screen(props) {
  const navigateUrl = useNavigate();
  let params = useParams();
  let location = useLocation();
  const { scrDefinition, sections, getData } = props.store;
  const { isAuthenticated } = props.main;

  useEffect(() => {
    props.main.checkLoginUser(
      navigateUrl,
      //props.match.url,
      location.pathname,
      props.appType ?? "desk",
      { ...params, isScreen: true }
    );
    props.store.doActivate(params);
  }, []);

  useEffect(() => {
    if (isAuthenticated) getData();
  }, [isAuthenticated]);

  const { noMatch } = props.main;
  if (noMatch) {
    return (
      <div
        className="nomatch"
        /*fullWidth*/ dangerouslySetInnerHTML={{ __html: noMatch }}
      />
    );
  }

  return (
    <div id={`scr-${scrDefinition?.screen?.SCREEN_ID}`} className="scr-screen">
      <div
        id={`scrs-${scrDefinition?.screen?.SCREEN_ID}`}
        className="scr-sections"
      >
        <ScreenZone
          id="scr-header"
          scrDefinition={scrDefinition}
          sections={sections}
          scrZone="header"
        />
        <ScreenZone
          id="scr-main"
          scrDefinition={scrDefinition}
          sections={sections}
          scrZone="main"
        />
        <ScreenZone
          id="scr-footer"
          scrDefinition={scrDefinition}
          sections={sections}
          scrZone="footer"
        />
      </div>
      <ScreenZone
        id="scr-right"
        scrDefinition={scrDefinition}
        sections={sections}
        scrZone="right"
      />
    </div>
  );
}

export default inject((stores) => ({
  store: stores.screenStore,
  main: stores.mainStore,
}))(observer(Screen));
